// --- Our Modules --------------------------------------------------------------------------------
import "./styles.css";
// --- Logic --------------------------------------------------------------------------------------
type Props = {
    name: string;
    picture?: string | null;
    size?: number;
    bordered?: boolean;
    /** A rounded square rather than a circle — a company's logo is a mark, not a face. */
    rounded?: boolean;
};

/** Falls back to the first letter: most accounts here will never upload a picture. */
export default function Avatar({ name, picture, size = 28, bordered, rounded }: Props) {
    const className = `avatar${bordered ? " avatar--bordered" : ""}${rounded ? " avatar--rounded" : ""}`;
    const style = { width: size, height: size, fontSize: size * 0.42 };

    if (picture) return <img className={className} style={style} src={picture} alt={name} />;
    return (
        <span className={`${className} avatar--letter`} style={style}>
            {name?.trim()?.charAt(0) || "؟"}
        </span>
    );
}
